<div #fcomNotification *ngIf="status === CardsStatus.COMPLETE || status === CardsStatus.ERROR">
  <fcom-notification
    aria-live="polite"
    class="pr-small-y pr-clear-t mr-clear block"
    [theme]="status === CardsStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
    [iconName]="status === CardsStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
  >
    {{
      (status === CardsStatus.ERROR
        ? 'plus.profile.paymentCards.cardRemoveError'
        : 'plus.profile.paymentCards.cardRemoveSuccess'
      ) | finLocalization
    }}
  </fcom-notification>
</div>
<div class="relative loader" *ngIf="status === CardsStatus.LOADING">
  <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
</div>

<h3 #cardsHeading tabindex="-1" class="nordic-blue-900-text font-body-1 mr-medium-b inline-block">
  {{
    (cardTokens.length > 0 ? 'plus.profile.paymentCards.mySavedCards' : 'plus.profile.paymentCards.noSavedCards')
      | finLocalization
  }}
</h3>

<ng-container *ngIf="cardTokens.length > 0; else noSavedCardsText">
  <div
    *ngFor="let card of cardTokens; let i = index"
    class="card pr-small ms-medium-b border rounded-medium font-body-1 light-type"
  >
    <div class="flex flex--space-between ms-large-b">
      <div class="flex flex--middle">
        <span class="bold-type ms-xxsmall-r">{{ card.name }}</span> {{ card.cardType | titlecase }}
      </div>
      <div class="flex flex--space-around flex--middle">
        <span class="ps-xxsmall-r">****</span> {{ card.lastDigits }}
        <div class="card-svg flex flex--center grey-50-bg ps-xxsmall ms-xxsmall-l rounded-medium">
          <fcom-icon [category]="IconLibrary.PAYMENTS" [name]="card.svgName" class="icon-medium-payment"></fcom-icon>
        </div>
      </div>
    </div>
    <div class="flex flex--space-between flex--align-end">
      <div class="card-info">
        <div class="ms-xxsmall-b">
          {{
            (card.corporate ? 'plus.profile.paymentCards.corporateCard' : 'plus.profile.paymentCards.personalCard')
              | finLocalization
          }}
        </div>
        <div class="ms-xxsmall-b">
          {{ 'plus.profile.paymentCards.nameOnCard' | finLocalization }}: {{ card.cardHolder }}
        </div>
        <div>{{ 'plus.profile.paymentCards.expiryDate' | finLocalization }}: {{ card.expiryDate }}</div>
      </div>
      <button
        data-testid="loyalty-payment-card-remove-button"
        class="nordic-blue-900-text medium-type underline align-right"
        [type]="'button'"
        (click)="onOpenModal($event, card.token, i)"
      >
        {{ 'plus.profile.paymentCards.removeCard' | finLocalization }}
      </button>
    </div>
  </div>
</ng-container>

<ng-template #noSavedCardsText>
  <p>{{ 'plus.profile.paymentCards.addCardsInfo' | finLocalization }}</p>
</ng-template>

<fcom-modal
  data-testid="loyalty-payment-card-remove-modal"
  [title]="'plus.profile.removeCreditCardTitle' | finLocalization"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [(open)]="modalOpen"
  (confirm)="onRemoveCard(selectedToken, selectedId)"
>
  <p class="pr-small">{{ 'plus.profile.removeCreditCardText' | finLocalization }}</p>
</fcom-modal>
